import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import BrandMark from '../components/BrandMark';

import i18n from "../i18n";
const tr = i18n.t.bind(i18n);
const LoginPage = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [companyInput, setCompanyInput] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { company } = useParams();
  const [reason, setReason] = useState('');
  const LAST_COMPANY_KEY = 'bbqsync_last_company';

  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    setReason(q.get('reason') || '');
  }, []);

  // preload company from URL param or localStorage
  useEffect(() => {
    try {
      if (company) {
        setCompanyInput(company);
        localStorage.setItem(LAST_COMPANY_KEY, company.trim().toLowerCase());
      } else {
        const prev = localStorage.getItem(LAST_COMPANY_KEY);
        if (prev && !companyInput) setCompanyInput(prev);
      }
    } catch {}
  }, [company]);  // run when route param changes

  const prettyCompany = (() => {
    const c = (company || companyInput || '').trim();
    return c ? c[0].toUpperCase() + c.slice(1) : '';
  })();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const companyName = (company || companyInput).trim().toLowerCase();
        if (!companyName) {
          setError('Please enter your company');
          return;
        }
        try { localStorage.setItem(LAST_COMPANY_KEY, companyName); } catch {}
        const response = await axios.post(
          tr('{{API_BASE_URL}}/users/login/{{companyName}}', {
            API_BASE_URL: config.API_BASE_URL,
            companyName
          }),
          credentials,
          { withCredentials: true } // ensure session cookie on iOS
        );
        
        const { data } = await axios.get(tr('{{API_BASE_URL}}/csrf-token', {
          API_BASE_URL: config.API_BASE_URL
        }), { withCredentials: true });
        axios.defaults.headers.common['X-CSRF-Token'] = data.csrfToken;
        sessionStorage.setItem('csrfToken', data.csrfToken);          
        
        localStorage.setItem("user", JSON.stringify(response.data)); // Store user data
        await onLogin(response.data); // Pass user data to App component
        navigate('/', { replace: true }); // Redirect to home after login
    } catch (err) {
        setError('Invalid username or password');
    }
  };

  return (
    <div style={{ maxWidth: '200px', margin: '50px auto', textAlign: 'center' }}>
      {reason && (
        <div style={{
          background: reason === 'expired' ? '#fff3cd' : '#fdecea',
          color: reason === 'expired' ? '#664d03' : '#611a15',
          border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: 6,
          padding: '8px 12px',
          marginBottom: 12,
          fontSize: 14
        }}>
          {reason === 'expired'
            ? 'Your session has expired. Please log in again.'
            : 'The service is temporarily unavailable. Please try connecting again in a moment.'}
        </div>
      )}
      <h1 style={{ margin: '25px' }}>
        <BrandMark size={36} href="/home" />
      </h1>
      <>
          <h3>{tr('Login to:')}{' '}<i style={{color: 'darkBlue'}}>{prettyCompany}</i></h3>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          {!company && (
            <div style={{ marginBottom: 14 }}>
              <input
                type="text"
                name="company"
                id="company"
                placeholder={tr('Company')}
                value={companyInput}
                onChange={(e) => {
                  const v = e.target.value;
                  setCompanyInput(v);
                  try { localStorage.setItem(LAST_COMPANY_KEY, v.trim().toLowerCase()); } catch {}
                }}
                required
                autoComplete="organization"
                autoCapitalize="none"
                autoCorrect="off"
                style={{ width: '100%', padding: '8px' }}
              />
            </div>
          )}
          <form onSubmit={handleSubmit} autoComplete="on">
            <div style={{ marginBottom: '10px'}}>
              <input
                type="text"
                name="username"
                id="username"
                placeholder={tr('Username')}
                value={credentials.username}
                onChange={handleChange}
                required
                autoComplete="username"
                autoCapitalize="none"
                autoCorrect="off"                
                style={{ width: '100%', padding: '8px', marginTop: '5px' }}
              />
            </div>
            <div style={{ marginBottom: '10px'}}>
              <input
                type="password"
                name="password"
                id="current-password"
                placeholder={tr('Password')}
                value={credentials.password}
                onChange={handleChange}
                required
                autoComplete="current-password"
                style={{ width: '100%', padding: '8px', marginTop: '5px' }}
              />
            </div>
            <button type="submit" style={{ padding: '10px 20px', cursor: 'pointer' }}>{tr('Login')}</button>
          </form>
      </>
    </div>
  );
};

export default LoginPage;
